import React from 'react';
import { CheckCircleIcon, TrendingUpIcon, CreditCardIcon, ShieldCheckIcon, UsersIcon, HelpCircleIcon } from 'lucide-react';
import CTAButton from '../components/ui/CTAButton';
const SellerPage = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-678">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-700 to-blue-900 text-white py-20" data-id="element-679">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80')"
      }} data-id="element-680"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-681">
          <div className="max-w-3xl" data-id="element-682">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-683">
              Grow Your Business with MarketHub
            </h1>
            <p className="text-xl md:text-2xl mb-8" data-id="element-684">
              Join thousands of successful sellers and reach customers worldwide
              with our trusted marketplace platform.
            </p>
            <CTAButton to="/seller-signup" text="Start Selling Today" variant="secondary" size="lg" data-id="element-685" />
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16" data-id="element-686">
        <div className="container mx-auto px-4" data-id="element-687">
          <div className="text-center mb-16" data-id="element-688">
            <h2 className="text-3xl font-bold mb-4" data-id="element-689">Why Sell on MarketHub?</h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-690">
              Our seller-friendly platform is designed to help you succeed with
              powerful tools, fair fees, and dedicated support.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-691">
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-692">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-693">
                <TrendingUpIcon className="h-8 w-8 text-blue-600" data-id="element-694" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-695">
                Reach Millions of Customers
              </h3>
              <p className="text-gray-600" data-id="element-696">
                Get instant access to our global customer base and benefit from
                our marketing efforts to drive traffic to your products.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-697">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-698">
                <CreditCardIcon className="h-8 w-8 text-blue-600" data-id="element-699" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-700">
                Low Fees, Fast Payments
              </h3>
              <p className="text-gray-600" data-id="element-701">
                Enjoy competitive commission rates and receive payments quickly
                and securely through our trusted payment system.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-702">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-703">
                <ShieldCheckIcon className="h-8 w-8 text-blue-600" data-id="element-704" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-705">
                Secure and Protected
              </h3>
              <p className="text-gray-600" data-id="element-706">
                Our platform handles payment processing, fraud prevention, and
                customer service so you can focus on creating great products.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-707">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-708">
                <UsersIcon className="h-8 w-8 text-blue-600" data-id="element-709" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-710">Seller Community</h3>
              <p className="text-gray-600" data-id="element-711">
                Join our vibrant community of sellers to share tips,
                collaborate, and grow your business with fellow entrepreneurs.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-712">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-713">
                <HelpCircleIcon className="h-8 w-8 text-blue-600" data-id="element-714" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-715">Dedicated Support</h3>
              <p className="text-gray-600" data-id="element-716">
                Get help when you need it with our dedicated seller support team
                and comprehensive resources to help you succeed.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-717">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-718">
                <CheckCircleIcon className="h-8 w-8 text-blue-600" data-id="element-719" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-720">
                Easy to Get Started
              </h3>
              <p className="text-gray-600" data-id="element-721">
                Our simple onboarding process and intuitive seller tools make it
                quick and easy to start selling your products.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-16 bg-white" data-id="element-722">
        <div className="container mx-auto px-4" data-id="element-723">
          <div className="text-center mb-16" data-id="element-724">
            <h2 className="text-3xl font-bold mb-4" data-id="element-725">How It Works</h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-726">
              Start selling on MarketHub in three simple steps
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-727">
            <div className="text-center" data-id="element-728">
              <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-6" data-id="element-729">
                1
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-730">Create Your Shop</h3>
              <p className="text-gray-600" data-id="element-731">
                Sign up and complete your seller profile with your shop details
                and branding to establish your presence.
              </p>
            </div>
            <div className="text-center" data-id="element-732">
              <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-6" data-id="element-733">
                2
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-734">List Your Products</h3>
              <p className="text-gray-600" data-id="element-735">
                Upload product photos, write compelling descriptions, set
                prices, and organize your inventory.
              </p>
            </div>
            <div className="text-center" data-id="element-736">
              <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-6" data-id="element-737">
                3
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-738">Start Selling</h3>
              <p className="text-gray-600" data-id="element-739">
                Receive orders, ship products, and manage your growing business
                with our powerful seller tools.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-16 bg-gray-50" data-id="element-740">
        <div className="container mx-auto px-4" data-id="element-741">
          <div className="text-center mb-16" data-id="element-742">
            <h2 className="text-3xl font-bold mb-4" data-id="element-743">Seller Success Stories</h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-744">
              Hear from sellers who have grown their businesses with MarketHub
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-745">
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-746">
              <div className="flex items-center mb-6" data-id="element-747">
                <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Emma Wilson" className="w-16 h-16 rounded-full mr-4" data-id="element-748" />
                <div data-id="element-749">
                  <h4 className="font-semibold text-lg" data-id="element-750">Emma Wilson</h4>
                  <p className="text-gray-600" data-id="element-751">Handmade Jewelry Shop</p>
                </div>
              </div>
              <p className="text-gray-700 italic" data-id="element-752">
                "Since joining MarketHub two years ago, my jewelry business has
                grown by 300%. The exposure to new customers and the easy-to-use
                platform have been game-changers for my small business."
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-753">
              <div className="flex items-center mb-6" data-id="element-754">
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="David Chen" className="w-16 h-16 rounded-full mr-4" data-id="element-755" />
                <div data-id="element-756">
                  <h4 className="font-semibold text-lg" data-id="element-757">David Chen</h4>
                  <p className="text-gray-600" data-id="element-758">Vintage Home Decor</p>
                </div>
              </div>
              <p className="text-gray-700 italic" data-id="element-759">
                "The seller tools and analytics have helped me understand what
                products sell best. MarketHub's support team has been incredibly
                helpful whenever I've had questions about growing my business."
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Fee Structure */}
      <section className="py-16 bg-white" data-id="element-760">
        <div className="container mx-auto px-4" data-id="element-761">
          <div className="text-center mb-16" data-id="element-762">
            <h2 className="text-3xl font-bold mb-4" data-id="element-763">
              Simple, Transparent Fees
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-764">
              We believe in keeping our fee structure simple and fair so you can
              focus on growing your business
            </p>
          </div>
          <div className="max-w-4xl mx-auto" data-id="element-765">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-766">
              <div className="bg-gray-50 p-8 rounded-xl border border-gray-200" data-id="element-767">
                <h3 className="text-xl font-semibold mb-3" data-id="element-768">Listing Fee</h3>
                <div className="text-4xl font-bold text-blue-600 mb-4" data-id="element-769">
                  Free
                </div>
                <p className="text-gray-600 mb-4" data-id="element-770">
                  List as many products as you want with no upfront costs.
                </p>
                <ul className="text-gray-600 space-y-2" data-id="element-771">
                  <li className="flex items-start" data-id="element-772">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-773" />
                    <span data-id="element-774">Unlimited product listings</span>
                  </li>
                  <li className="flex items-start" data-id="element-775">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-776" />
                    <span data-id="element-777">Multiple product photos</span>
                  </li>
                  <li className="flex items-start" data-id="element-778">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-779" />
                    <span data-id="element-780">Detailed product descriptions</span>
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 p-8 rounded-xl border border-blue-200 transform md:scale-110 z-10 shadow-md" data-id="element-781">
                <div className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-3" data-id="element-782">
                  MOST POPULAR
                </div>
                <h3 className="text-xl font-semibold mb-3" data-id="element-783">Transaction Fee</h3>
                <div className="text-4xl font-bold text-blue-600 mb-4" data-id="element-784">5%</div>
                <p className="text-gray-600 mb-4" data-id="element-785">
                  Simple percentage fee on each sale with no hidden costs.
                </p>
                <ul className="text-gray-600 space-y-2" data-id="element-786">
                  <li className="flex items-start" data-id="element-787">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-788" />
                    <span data-id="element-789">Secure payment processing</span>
                  </li>
                  <li className="flex items-start" data-id="element-790">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-791" />
                    <span data-id="element-792">Fraud protection included</span>
                  </li>
                  <li className="flex items-start" data-id="element-793">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-794" />
                    <span data-id="element-795">Fast payouts to your account</span>
                  </li>
                </ul>
              </div>
              <div className="bg-gray-50 p-8 rounded-xl border border-gray-200" data-id="element-796">
                <h3 className="text-xl font-semibold mb-3" data-id="element-797">Subscription</h3>
                <div className="text-4xl font-bold text-blue-600 mb-4" data-id="element-798">
                  Optional
                </div>
                <p className="text-gray-600 mb-4" data-id="element-799">
                  Premium plans available for high-volume sellers.
                </p>
                <ul className="text-gray-600 space-y-2" data-id="element-800">
                  <li className="flex items-start" data-id="element-801">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-802" />
                    <span data-id="element-803">Reduced transaction fees</span>
                  </li>
                  <li className="flex items-start" data-id="element-804">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-805" />
                    <span data-id="element-806">Advanced analytics</span>
                  </li>
                  <li className="flex items-start" data-id="element-807">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-808" />
                    <span data-id="element-809">Priority customer support</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ */}
      <section className="py-16 bg-gray-50" data-id="element-810">
        <div className="container mx-auto px-4" data-id="element-811">
          <div className="text-center mb-16" data-id="element-812">
            <h2 className="text-3xl font-bold mb-4" data-id="element-813">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-814">
              Get answers to common questions about selling on MarketHub
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-815">
            <div className="space-y-6" data-id="element-816">
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-817">
                <h3 className="font-semibold text-lg mb-2" data-id="element-818">
                  How do I start selling on MarketHub?
                </h3>
                <p className="text-gray-600" data-id="element-819">
                  Simply sign up for a seller account, complete your profile
                  with shop details, list your products with high-quality photos
                  and descriptions, and start receiving orders. Our step-by-step
                  guide will walk you through the entire process.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-820">
                <h3 className="font-semibold text-lg mb-2" data-id="element-821">
                  What can I sell on MarketHub?
                </h3>
                <p className="text-gray-600" data-id="element-822">
                  You can sell a wide range of products including handmade
                  items, vintage goods, craft supplies, clothing, home decor,
                  jewelry, electronics, and more. All products must comply with
                  our marketplace policies and quality standards.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-823">
                <h3 className="font-semibold text-lg mb-2" data-id="element-824">
                  How do payments work?
                </h3>
                <p className="text-gray-600" data-id="element-825">
                  When a customer makes a purchase, the payment is processed
                  securely through our platform. Funds are held until the order
                  is fulfilled and then transferred to your connected bank
                  account, minus our transaction fee. Payouts occur on a weekly
                  basis.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-826">
                <h3 className="font-semibold text-lg mb-2" data-id="element-827">
                  How do I handle shipping?
                </h3>
                <p className="text-gray-600" data-id="element-828">
                  Sellers are responsible for shipping their products to
                  customers. You can set your own shipping rates or use our
                  shipping calculator. Once an order is placed, you'll receive a
                  notification to prepare and ship the item with the provided
                  shipping details.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-829">
                <h3 className="font-semibold text-lg mb-2" data-id="element-830">
                  What support does MarketHub provide to sellers?
                </h3>
                <p className="text-gray-600" data-id="element-831">
                  We provide comprehensive seller education resources, marketing
                  tools, analytics dashboards, and dedicated customer support.
                  Our Seller Success team is available to help you optimize your
                  shop, resolve issues, and grow your business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-16 bg-blue-600 text-white" data-id="element-832">
        <div className="container mx-auto px-4 text-center" data-id="element-833">
          <h2 className="text-3xl font-bold mb-4" data-id="element-834">Ready to Start Selling?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-835">
            Join thousands of successful sellers on MarketHub today and turn
            your passion into a thriving business.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-836">
            <CTAButton to="/seller-signup" text="Create Seller Account" variant="secondary" size="lg" data-id="element-837" />
            <CTAButton to="/seller-guide" text="Read Seller Guide" variant="outline" size="lg" data-id="element-838" />
          </div>
        </div>
      </section>
    </div>;
};
export default SellerPage;